import CryptoJS from 'crypto-js';

const CRYPTO_KEY = process.env.REACT_APP_CRYPTO_KEY || '';
const KEY = CryptoJS.enc.Utf8.parse(CRYPTO_KEY);
const IV = CryptoJS.enc.Utf8.parse(CRYPTO_KEY.substr(0, 16));

/**
 * Encrypts a plaintext string using AES (CBC mode with PKCS7 padding).
 * @param {string} plainText
 * @returns {string} Base64-encoded encrypted string
 */
export const encryptData = (plainText) => {
  const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString(); // Returns Base64 string
};

/**
 * Decrypts a Base64-encoded AES-encrypted string.
 * @param {string} encryptedText
 * @returns {string} Decrypted plaintext string
 */
export const decryptData = (encryptedText) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
};
